/**
 * CORE-1730 — сообщение из одних фирменных эмодзи: ряд картинок комплекта
 * без пузыря. Одна — 72, две или три — по 48 через 8, с переносом на новую
 * строку, когда не влезают в ширину сообщения. Те же ассеты, что в строке и
 * в реакциях (`ReactionGlyph`), без фильтров и обводки; подпись доступности —
 * русские названия эмодзи из комплекта. Общий для личных чатов (включая
 * раздел сообщений) и Live-чата: размеры одни на весь веб (ТЗ).
 */
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { EMOJI_ONLY_GROUP_GAP, emojiOnlyLabel, emojiOnlySize } from '../../utils/emojiOnlyMessage';
import { ReactionGlyph } from './ReactionGlyph';

interface Props {
  /** Слаги из `emojiOnlyTokens`. */
  types: readonly string[];
  /** Своё сообщение: последняя строка переноса прижата вправо. */
  mine?: boolean;
  testID?: string;
}

export const EmojiOnlyMessage: React.FC<Props> = ({ types, mine, testID = 'chat-message-emoji-only' }) => {
  const size = emojiOnlySize(types.length);
  return (
    <View
      style={[styles.row, mine ? styles.rowMine : styles.rowTheirs]}
      accessible
      accessibilityRole="image"
      accessibilityLabel={emojiOnlyLabel(types)}
      testID={testID}
    >
      {types.map((type, i) => (
        <ReactionGlyph key={`${type}-${i}`} type={type} size={size} decorative />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  row: { flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center', gap: EMOJI_ONLY_GROUP_GAP },
  rowMine: { justifyContent: 'flex-end' },
  rowTheirs: { justifyContent: 'flex-start' },
});
